import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Kicker, H2 } from './ui/Typography';
import { useT } from '../i18n/LanguageContext';
export function TestimonialsSection() {
  const t = useT().testimonials;
  return <Section hasOrb={true} data-id="element-184">
      <div className="text-center mb-16" data-id="element-185">
        <div className="flex justify-center" data-id="element-186">
          <Kicker data-id="element-187">{t.kicker}</Kicker>
        </div>
        <H2 className="max-w-4xl mx-auto" data-id="element-188">{t.title}</H2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-189">
        {t.items.map((item, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.01
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="relative bg-[rgba(255,255,255,0.02)] border border-border rounded-[16px] p-8 hover:border-brand/30 transition-colors" data-id="element-190">
            {/* Stars */}
            <div className="flex gap-1 mb-4" data-id="element-191">
              {[...Array(5)].map((_, j) => <span key={j} className="text-brand text-lg" data-id="element-192">★</span>)}
            </div>

            {/* Quote */}
            <p className="text-ink text-lg leading-relaxed mb-6" data-id="element-193">
              “{item.quote}”
            </p>

            {/* Result highlight */}
            <div className="inline-block bg-brand/10 border border-brand/30 rounded-[8px] px-3 py-1.5 mb-4" data-id="element-194">
              <span className="font-mono text-xs font-bold text-brand uppercase tracking-[0.14em]" data-id="element-195">
                {item.result}
              </span>
            </div>

            {/* Attribution */}
            <div className="flex items-center gap-3 pt-4 border-t border-border" data-id="element-196">
              <div className="w-10 h-10 rounded-full bg-brand/20 border border-brand/40 flex items-center justify-center" data-id="element-197">
                <span className="font-archivo text-brand text-sm" data-id="element-198">{item.initials}</span>
              </div>
              <div data-id="element-199">
                <div className="font-bold text-ink text-sm" data-id="element-200">{item.name}</div>
                <div className="font-mono text-xs text-ink-dim uppercase tracking-wider" data-id="element-201">
                  {item.role}
                </div>
              </div>
              <div className="ml-auto" data-id="element-202">
                <span className="font-mono text-xs text-ink-dim/60 uppercase tracking-wider" data-id="element-203">
                  Verified buyer
                </span>
              </div>
            </div>
          </motion.div>)}
      </div>

      {/* Bottom note */}
      <motion.p initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true,
      amount: 0.01
    }} transition={{
      duration: 0.5,
      delay: 0.3
    }} className="text-center text-ink-dim text-sm mt-12 max-w-2xl mx-auto" data-id="element-204">
        {t.footnote}
      </motion.p>
    </Section>;
}